<template>
  <div
    element-loading-text="登录中..."
    element-loading-background="rgba(0, 0, 0, 0.4)"
    v-loading.fullscreen.lock="loading"
    class="loginpage"
  >
    <img class="bg" src="../assets/img/bg.svg" alt />
    <div id="allmap"></div>
    <div class="div1">
      <div class="login1">
        <h2>登录账户</h2>
        <div v-if="logintype == 1">
          <el-input
            size="small"
            placeholder="请输入用户名"
            v-model="tel"
            style="margin-bottom: 20px;"
            maxlength="11"
            minlength="11"
          >
            <i slot="prepend" class="el-icon-edit" />
          </el-input>
          <el-input size="small" placeholder="请输入密码" v-model="password" type="password">
            <i slot="prepend" class="el-icon-view" />
          </el-input>
          <el-checkbox class="lab" v-model="eck">记住密码</el-checkbox>
          <!--<label class="lab">-->
          <!--  <span>-->
          <!--    <input-->
          <!--      style="margin-right: 10px;"-->
          <!--      type="checkbox"-->
          <!--      value="记住密码"-->
          <!--      v-model="eck"-->
          <!--      @change="test()"-->
          <!--    />记住密码-->
          <!--  </span>-->
          <!--</label>-->
          <button @click="login()">登录</button>
        </div>
        <!-- <div v-else>
                   <el-input placeholder="请输入用户名" v-model="tel" style="margin-bottom: 20px;" maxlength="11" minlength="11">
                        <el-button slot="prepend" icon="el-icon-edit"></el-button>
                    </el-input>
                   <el-input placeholder="请输入验证码" v-model="mscode">
                        <el-button slot="prepend" icon="el-icon-view"></el-button>
                        <el-button slot="append" v-if="ifsend == 1" @click="send()">发送验证码</el-button>
                        <el-button slot="append" v-if="ifsend == 2">{{time}}</el-button>
                    </el-input>
                    <p ><i @click="other()">账号密码登录</i></p>
                    <button @click="login1()">登录</button>
        </div>-->
      </div>
      <div class="login2">
        <div class="tpl-login-logo">

          <!-- <img :src="imgUrl+img.logo" alt style="width: 64%;border:none;" /> -->
          <img src="../assets/img/logo_lf.png" alt style="width: 64%;border:none;" />
        </div>
        <center>
          <!-- <img :src="imgUrl+img.wxsrc" alt /> -->
          <!--<img src="../assets/img/gzh_lf.png" alt />-->
          <canvas ref="canvas" class="qrcode" />
        </center>
        <p>扫一扫登录手机端</p>
      </div>
    </div>
    <div class="btn_to">
      <a target="_blank" href="http://www.miit.gov.cn/">蜀ICP备19028776号-1</a>&emsp;Copyright © 2022&emsp;<a target="_blank" href="http://www.sclf.top/">四川翎锋科技有限公司</a>&emsp;乡村群宴智慧平台&emsp;All Rights Reserved
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import CryptoJS from "crypto-js";
export default {
  name: "login",
  components: {QRCode},
  data() {
    return {
      logintype: 1,
      tel: null,
      username: null,
      password: null,
      mscode: null,
      time: 60,
      ifsend: 1,
      baseinfo: {},
      loading: false,
      eck: false,
      stat: 0,
      results: "",
      img: {},
      imgUrl: this.$Public.imgUrl
    };
  },
  created() {
    // if(localStorage.getItem('region')!=undefined){
    //     this.$router.push({  //核心语句
    //         path:'/index',   //跳转的路径
    //         name:'index',
    //     })
    // }
    if (localStorage.getItem("pwdstat") == 1) {
      this.eck = true;
      this.stat = 1;
      let obj = localStorage.getItem("pwd");
      let pwds = CryptoJS.AES.decrypt(JSON.parse(obj).pwd, "pwd");
      let pwd = pwds.toString(CryptoJS.enc.Utf8);
      this.tel = JSON.parse(obj).ueser;
      this.password = pwd;
    } else {
      this.eck = false;
      this.stat = 0;
    }
    var lett = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        lett.login();
      }
    };
  },
  methods: {
    test: function() {
      if (this.eck) {
        localStorage.setItem("pwdstat", 1);
        this.$set(this, "stat", 1);
      } else {
        localStorage.setItem("pwdstat", 0);
        this.$set(this, "stat", 0);
      }
    },
    phone() {
      this.logintype = 2;
    },
    login() {
      this.$set(this, "loading", true);
      let data = this.$qs.stringify({
        username: this.tel,
        password: this.password
      });
      this.$axios.post(`/api-r/sys/login`, data).then(res => {
        if (res.data.success == true) {
          if (this.stat == 1) {
            // Encrypt，加密账号密码
            let password = CryptoJS.AES.encrypt(
              this.password,
              "pwd"
            ).toString();
            let obj = {
              ueser: this.tel,
              pwd: password
            };
            localStorage.setItem("pwd", JSON.stringify(obj));
          } else {
            localStorage.setItem("pwdstat", 0);
            this.$set(this, "stat", 0);
          }
          this.$set(this, "loading", false);
          // 匹配逗号替换 /

          let userdata = {
            username: res.data.sysUserInfo.username,
            nickname: res.data.sysUserInfo.nickname,
            roleId: res.data.sysUserInfo.roleId,
            id: res.data.sysUserInfo.id,
            token: res.data.accessToken,
            areasId: res.data.sysUserInfo.areasId,
            level: res.data.sysUserInfo.level,
            areasExtend: res.data.sysUserInfo.areasExtend,
            areasName: res.data.sysUserInfo.areasName
          };
          sessionStorage.setItem("userdata", JSON.stringify(userdata));
          this.$set(this, "loading", false);
          this.$router.push({
            //核心语句
            path: "/index", //跳转的路径
            name: "index"
          });
        } else {
          this.$set(this, "loading", false);
          this.$message.error(res.data.msg);
        }
      });
    },
    send() {},
    other() {
      this.logintype = 1;
    },
    myFun(result) {
      this.results = result.name;
      sessionStorage.setItem("citylat", JSON.stringify(result.center));
      this.$axios
        .post(
          `/api-r/data/getBaseInfoByCityName`,
          this.$qs.stringify({ cityName: this.results })
        )
        .then(res => {
          if (res.data.success) {
            this.img = res.data.baseInfo;
          } else {
            this.$message(res.data.msg);
          }
        });
    }
  },
  mounted() {
    var that = this;
    var myCity = new BMap.LocalCity();

    myCity.get(this.myFun);

    this.$nextTick(() => {
      const canvas = this.$refs.canvas
      QRCode.toCanvas(
        canvas,
        window.location.origin + '/h5',
        function (error) {
          if (error) console.error(error)
        }
      )
    })
    // console.log('登陆',myCity)
  }
};
</script>
<style lang="scss">
.loginpage {
  background-color: hsl(210 40% 98%);
}
.loginpage .el-input__inner {
  margin: 0;
}
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
}
.div1 {
  position: absolute;
  left: 50%;
  // height: 42%;
  transform: translate(-50%, 50%);
  width: 800px;
  background-color: #fff;
  padding-top: 40px;
  border-radius: 5px;
  box-shadow: 0 0 #0000,0 0 #0000,0 1px 3px #0000001a,0 1px 2px -1px #0000001a;
  border: 1px solid hsl(214.3 31.8% 91.4%);
}
.div1 > .login1 {
  width: 500px;
  height: 100%;
  float: left;
  border-right: 1px solid #eee;
  box-sizing: border-box;
}
.div1 > .login1 > h2 {
  text-align: center;
  font-size: 22px;
}
.div1 > .login1 > div {
  width: 400px;
  margin: 0 auto;
  margin-top: 46px;
}
.div1 > .login1 > div p {
  text-align: right;
  line-height: 62px;
}
.div1 > .login1 > div p span {
  float: left;
  display: inline-block;
  font-size: 14px;
  color: #409eff;
}
.div1 > .login1 > div p i {
  font-style: normal;
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
}
.div1 > .login1 > div > button {
  width: 100%;
  border: none;
  background-color: #4bce81;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 4px;
  box-shadow: 0 5px 13px #13864233;
  background: -webkit-linear-gradient(
    left,
    #02abb5,
    #17d0b3
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    right,
    #02abb5,
    #17d0b3
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    right,
    #02abb5,
    #17d0b3
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #02abb5, #17d0b3);
}
.div1 .login2 {
  width: 300px;
  height: 100%;
  float: left;
}
.div1 .login2 p:nth-child(3) {
  text-align: center;
  color: #a29c9c;
  font-size: 16px;
  margin: 0;
  line-height: 50px;
  font-weight: bold;
}
.div1 .login2 img {
  width: 150px;
  margin-top: 10px;
  border: 1px solid #eee;
}
.tpl-login-logo {
  text-align: center;
}
.lab {
  margin: 20px 0;
  display: block;
  font-size: 14px;
  color: #999;
}
.login2 {
  padding-bottom: 20px;
}

.btn_to {
  width: 100%;
  position: fixed;
  bottom: 10%;
  font-size: 12px;
  color: #a29c9c;
  text-align: center;
}
.btn_to > a {
  cursor: pointer;
  color: #a29c9c !important;
}
.btn_to > a:last-child:hover {
  color: #11A983 !important;
  font-weight: 550;
}
</style>
